import { createUseStyles } from "react-jss";

import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: theme.spacing.space20,
  },
  title: {
    padding: `${theme.spacing.space20}px 0 ${theme.spacing.space20}px 0`,
  },
  description: {
    textAlign: "center",
  },
}));
